module.exports = __webpack_public_path__ + "img/BUCK-SLIDER-01.65d91b51.jpg";